import React, { useEffect } from 'react';

import styled from '@emotion/styled';

import BarChart from '../../../components/Charts/BarChart';
import ChartWrapper from '../../../components/Charts/ChartWrapper';
import ChartEmptyTableIcon from '../../../components/Icons/ChartEmptyTableIcon';
import Table from '../../../components/Table/Table';
import TableImageWithLabel from '../../../components/Table/TableAccessories/TableImageWithLabel';
import TableNumberBadge from '../../../components/Table/TableAccessories/TableNumberBadge';
import TableNumberFormatter from '../../../components/Table/TableAccessories/TableNumberFormatter';
import TableStarRattingFormatter from '../../../components/Table/TableAccessories/TableStarRattingFormatter';
// import SortBy from '../../../components/Table/TableSortForm/SortBy';
import ToggleThenAddToQuery from '../../../components/Table/TableSortForm/ToggleThenAddToQuery';
import Tooltip from '../../../components/Tooltip/Tooltip';
import useVehicleVolumeType from '../../../hooks/dashboard/dashboard/useVehicleVolumeType';

const TableAndBarChart = () => {
  const { getVehicleVolumeTypeData, vehicleVolumeTypeData } =
    useVehicleVolumeType();

  useEffect(() => {
    getVehicleVolumeTypeData();
    // eslint-disable-next-line
  }, []);

  return (
    <Container>
      {/* Table area */}
      <Table
        className='scrollable-table'
        border
        disableMobileComp
        borderRadius='8px'
        rmHeaderBorder
        addRowBorder
        height={320}
        stickyHeader
        headerBgColor='#F8F8F7'
        firstColumnOffset='20px'
        emptyStateMsg={{
          label: 'No data to display',
          icon: <ChartEmptyTableIcon />,
          optionalComp: (
            <span>Driver type distribution will be displayed here</span>
          ),
        }}
        tableColumnWidth={{
          'Driver name': '36%',
          Rating: '20%',
          Trips: '20%',
          Logiscore: '24%',
        }}
        tableFilterBoxFeatures={{
          rightAttr: [
            {
              type: 'custom-filter',
              comp: (
                <ToggleThenAddToQuery
                  sortField={['Default', 'Top Performing', 'Least Performing']}
                  sortValueMap={{
                    Default: 'default',
                    'Top Performing': 'topRated',
                    'Least Performing': 'leastRated',
                  }}
                />
              ),
            },
          ],
          leftAttr: [
            {
              type: 'regular',
              comp: (
                <Label>
                  Rated Drivers{' '}
                  <Tooltip content='This information is updated on a weekly basis' />
                </Label>
              ),
            },
          ],
        }}
        tableHeader={{
          'Driver name': 'driverName',
          Rating: 'averageRating',
          Trips: 'numberOfTrips',
          Logiscore: 'logirateScore',
        }}
        tableDataSourceUrl='api/v1/company/rated-drivers'
        cellsCustomComp={{
          driverName: (
            <TableImageWithLabel
              dataKey='driverName'
              imageUrlKey='driverImageUrl'
            />
          ),
          averageRating: <TableStarRattingFormatter dataKey='averageRating' />,
          numberOfTrips: <TableNumberFormatter dataKey='numberOfTrips' />,
          logirateScore: <TableNumberBadge dataKey='logirateScore' />,
        }}
        size={10}
        showPaginationControl={false}
      />

      {/* Bar chart Area */}
      <ChartWrapper label='Vehicle volume by type' maxWidth='100%' radius='8px'>
        <BarChart
          xAxisDataKey='name'
          data={vehicleVolumeTypeData}
          isAnimationActive={true}
          dataKeys={['value']}
          fills={['#5B91F5']}
          showLegend={false}
          // yLabel='Average Tier Score per month'
        />
      </ChartWrapper>
    </Container>
  );
};

export default TableAndBarChart;

const Container = styled.div`
  height: fit-content;
  /* display: grid; */
  display: flex;
  flex-direction: column-reverse;
  /* grid-template-columns: repeat(1, 1fr); */
  /* Reverse the stack order */
  grid-auto-flow: row dense; /* This will reverse the stack order */
  gap: 28px;

  /* @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  } */

  @media (max-width: 884px) {
    /* grid-template-columns: 1fr; */

    & > * {
      min-width: 0;
      overflow-x: auto;
    }

    /* Table.tsx forces min-width: max-content on .scrollable-table — reset it so it scrolls inside the grid cell */
    .scrollable-table {
      min-width: unset;
    }
  }
`;

const Label = styled.div`
  font-weight: 600;
  font-size: 18px;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;
